import { render, staticRenderFns } from "./minrent.vue?vue&type=template&id=65f10826&scoped=true&"
import script from "./minrent.vue?vue&type=script&lang=js&"
export * from "./minrent.vue?vue&type=script&lang=js&"
import style0 from "./minrent.vue?vue&type=style&index=0&id=65f10826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f10826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f10826')) {
      api.createRecord('65f10826', component.options)
    } else {
      api.reload('65f10826', component.options)
    }
    module.hot.accept("./minrent.vue?vue&type=template&id=65f10826&scoped=true&", function () {
      api.rerender('65f10826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-263JZWhpgzOOV/JS/minrent.vue"
export default component.exports